import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Alert } from "react-bootstrap";

import Header from "./components/Header";
import Main from "./components/Main";
import Basket from "./components/Basket";
import Footer from "./components/Footer";
import data from "./components/data";
import cat from "./components/cat";
import NavigationBar from "./components/NavigationBar";

function generateOrderID(length = 5) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

function App() {
  const { products } = data;
  const { categories } = cat;
  const [cartItems, setCartItems] = useState([]);
  const [filter, setFilter] = useState("");
  const [notification, setNotification] = useState({
    show: false,
    message: "",
    variant: "success",
  });

  const itemsPrice = cartItems.reduce((a, c) => a + c.qty * c.price, 0);
  const taxPrice = itemsPrice > 70 ? 0 : 8;
  const totalPrice = itemsPrice + taxPrice;

  const showNotification = (message, variant = "success") => {
    setNotification({
      show: true,
      message,
      variant,
    });
  };

  useEffect(() => {
    if (!notification.show) return;

    const timer = setTimeout(() => {
      setNotification((prev) => ({ ...prev, show: false }));
    }, 2000);

    return () => clearTimeout(timer);
  }, [notification.show]);

  const onPost = (
    cartItems,
    { name, phone, address, addresstwo, postal, note },
  ) => {
    const orderID = generateOrderID(5);

    let orderData = "New order 🛵 (SuperValueCart) \n (# " + orderID + ") \n\n";

    cartItems.forEach((item) => {
      orderData += "◾️\t" + item.qty + "X" + item.englishname + "\n\n";
    });

    orderData +=
      "*Payable: S$ " +
      totalPrice +
      "*" +
      "\n\n" +
      "*Customer details*\n" +
      name +
      "\n" +
      phone +
      "\n" +
      address +
      "\n" +
      addresstwo +
      "\n" +
      postal +
      "\n\n" +
      "*Note From Customer:*\n" +
      note +
      "\n****\n______________\n(Message for customer)\n\nThank you for your order.\nPlease pay using PayNow to UEN 202030732E";

    window.open(
      "https://api.whatsapp.com/send?text=" +
        urlencode(orderData) +
        "&phone=123456789?",
      "_blank",
    );
  };

  function urlencode(str) {
    str = str + "";
    return encodeURIComponent(str)
      .replace(/!/g, "%21")
      .replace(/'/g, "%27")
      .replace(/\(/g, "%28")
      .replace(/\)/g, "%29")
      .replace(/\*/g, "%2A")
      .replace(/~/g, "%7E")
      .replace(/%20/g, "+");
  }

  const onAdd = (product) => {
    const exist = cartItems.find((x) => x.id === product.id);

    if (exist) {
      setCartItems(
        cartItems.map((x) =>
          x.id === product.id ? { ...exist, qty: exist.qty + 1 } : x,
        ),
      );
    } else {
      setCartItems([...cartItems, { ...product, qty: 1 }]);
    }

    showNotification("Added to cart successfully", "success");
  };

  const onRemove = (product) => {
    const exist = cartItems.find((x) => x.id === product.id);

    if (!exist) return;

    if (exist.qty === 1) {
      setCartItems(cartItems.filter((x) => x.id !== product.id));
    } else {
      setCartItems(
        cartItems.map((x) =>
          x.id === product.id ? { ...exist, qty: exist.qty - 1 } : x,
        ),
      );
    }

    showNotification("Removed from cart successfully", "danger");
  };

  return (
    <div
      className="App"
      style={{ backgroundColor: "#01786f", minHeight: "100vh" }}
    >
      {notification.show && (
        <div
          style={{
            position: "fixed",
            top: "15px",
            left: "15px",
            zIndex: 9999,
            minWidth: "260px",
          }}
        >
          <Alert
            variant={notification.variant}
            onClose={() =>
              setNotification((prev) => ({ ...prev, show: false }))
            }
            dismissible
            className="shadow"
          >
            {notification.message}
          </Alert>
        </div>
      )}

      <Header />

      <Container
        fluid
        className="px-3 px-sm-2 px-md-4 px-lg-5 pt-4"
        style={{
          fontVariant: "small-caps",
          backgroundColor: "#EAE6E5",
        }}
      >
        <Row className="px-0 px-sm-2 px-md-4 px-lg-5">
          <Col md={8}>
            <NavigationBar
              categories={categories}
              filter={filter}
              setFilter={setFilter}
            />
            <Main
              products={products.filter((prod) =>
                prod.englishname.toLowerCase().includes(filter.toLowerCase()),
              )}
              onAdd={onAdd}
            />
          </Col>

          <Col md={4} sm={12}>
            <Basket
              cartItems={cartItems}
              onAdd={onAdd}
              onRemove={onRemove}
              itemsPrice={itemsPrice}
              taxPrice={taxPrice}
              totalPrice={totalPrice}
              onPost={onPost}
            />
          </Col>
        </Row>
      </Container>

      <div className="mt-5">
        {cartItems.length > 0 && (
          <Footer
            countCartItems={cartItems.reduce(
              (acc, value) => acc + value.qty,
              0,
            )}
            totalPrice={totalPrice}
          />
        )}
      </div>
    </div>
  );
}

export default App;
